/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Digest_EyebrowInputs */

const en_platform_digest_eyebrow = /** @type {(inputs: Platform_Digest_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reminders`)
};

const pl_platform_digest_eyebrow = /** @type {(inputs: Platform_Digest_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przypomnienia`)
};

/**
* | output |
* | --- |
* | "Reminders" |
*
* @param {Platform_Digest_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_digest_eyebrow = /** @type {((inputs?: Platform_Digest_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Digest_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_digest_eyebrow(inputs)
	return en_platform_digest_eyebrow(inputs)
});